import { render } from "./ChangeTenantModal.vue?vue&type=template&id=d11b18f4"
import script from "./ChangeTenantModal.vue?vue&type=script&lang=js"
export * from "./ChangeTenantModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__